import { Drawer as MantineDrawer } from "@mantine/core";
import type { CustomDrawerContentFactory, IProps } from "./drawer-content.types";
import { componentWrapper } from "../../../utilities";

const DrawerContent = componentWrapper<CustomDrawerContentFactory, IProps>("DrawerContent", (props, ref) => {
    return <MantineDrawer.Content ref={ref} {...props} />;
});

export { DrawerContent };
